/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByCloudAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByCloudAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByCloudAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByCloudAccountWidgetConfiguration>): CostSpendByCloudAccountWidgetConfiguration {
        let obj = Object.assign(new CostSpendByCloudAccountWidgetConfiguration(), model);
        CostSpendByCloudAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByCloudAccountWidgetConfiguration>): CostSpendByCloudAccountWidgetConfiguration {
        if (!model) return null;
        return CostSpendByCloudAccountWidgetConfiguration.newInstance(<CostSpendByCloudAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByCloudAccountWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByCloudAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByCloudAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByCloudAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
